import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'

import { BlacklistPassengerBookings as View } from './BlacklistPassengerBookings'

import { blacklistActions } from 'reduxModules/actions/BlacklistActions'
import {
  blacklistPassengerBookingsSelector,
  isLoadingBlacklistModalSelector
} from 'reduxModules/selectors/BlacklistSelectors'
import { dataSelector } from 'reduxModules/selectors/ModalSelectors'

const mapStateToProps = createStructuredSelector({
  isLoadingBlacklistModal: isLoadingBlacklistModalSelector,
  data: dataSelector,
  blacklistPassengerBookings: blacklistPassengerBookingsSelector
})

const mapDispatchToProps = {
  getBlacklistPassengerBookings: blacklistActions.getBlacklistPassengerBookings
}

export const BlacklistPassengerBookings = connect(mapStateToProps, mapDispatchToProps)(View)


// WEBPACK FOOTER //
// ./src/components/BlacklistPassengerBookings/index.js